<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-chisiamo.png"
      background-color="bg-black-light"
    >
      <template slot="title"> UniCredit RE Services </template>
      <template slot="description"
        >Scegliere UniCredit Re Services significa affidarsi a un team di
        esperti nel settore immobiliare, supportato da strumenti tecnologici
        avanzati per semplificare ogni fase della compravendita.</template
      >
    </VisualHero>
    <section class="container mb-16">
      <Breadcrumbs :items="breadcrumbs" label="label" url="url" />
      <h2 class="section-title my-20">Oltre l'immobiliare</h2>
      <p class="mb-10">
        Con il passaggio da UniCredit SubitoCasa a
        <strong>UniCredit RE Services</strong>, abbiamo
        <strong>ampliato i nostri servizi</strong> per fornirti un'assistenza
        <strong>su misura</strong>, assicurandoti sempre la massima competenza e
        trasparenza.
      </p>
      <p>
        Il nostro obiettivo è rendere la
        <strong>compravendita immobiliare</strong> sinonimo di
        <strong>fiducia</strong> e <strong>affidabilità</strong> in ogni fase
        del percorso.
      </p>
      <h3 class="section-headline text-center my-20">
        Perché scegliere UniCredit RE Services
      </h3>
      <ClientOnly>
        <Swiper :options="{ ...swiperOptions, spaceBetween: 30 }">
          <div
            v-for="(item, index) of infos"
            :key="`UCRS-Info_${index}`"
            class="swiper-slide p-12 bg-white-dark"
          >
            <SvgIcon :name="item.icon" class="h-10 w-10 mb-4 text-red" />
            <h4 class="paragraph mb-10">
              {{ item.title }}
            </h4>
            <p v-dompurify-html="item.description" />
          </div>
        </Swiper>
      </ClientOnly>
    </section>
    <section class="py-24 bg-white-dark">
      <div class="container">
        <ClientOnly>
          <Swiper :options="swiperOptions">
            <div
              v-for="(card, index) in cards"
              :key="`TipsCard_${index}`"
              class="swiper-slide"
            >
              <TipsCard
                :item="card"
                :img="`/assets/img/${card.imgSrc}`"
                :gradient="false"
              >
              </TipsCard>
            </div>
          </Swiper>
        </ClientOnly>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import Swiper from '~/components/Swiper.vue'
import TipsCard from '~/components/TipsCard.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    Breadcrumbs,
    Swiper,
    TipsCard,
    VisualHero,
  },

  data() {
    return {
      breadcrumbs: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: 'Chi siamo',
        },
      ],

      infos: [
        {
          icon: 'agency',
          title: `Consulenti esperti, strumenti all'avanguardia`,
          description: `Con UniCredit RE Services puoi fare affidamento su un team di <strong>professionisti qualificati nel settore immobiliare</strong>, supportati da strumenti tecnologici avanzati.`,
        },
        {
          icon: 'chat',
          title: `Assistenza completa e personalizzata`,
          description: `Dalla valutazione alla promozione dell'immobile, fino alla gestione delle trattative, siamo al tuo fianco passo dopo passo con un <strong>approccio consulenziale</strong>, in linea con <strong>l'affidabilità</strong> e la <strong>solidità</strong> del Gruppo UniCredit.`,
        },
        {
          icon: 'house-search',
          title: `Professionisti specializzati in immobili commerciali e di pregio`,
          description: `Offriamo <strong>professionalità dedicate</strong> a <strong>imprenditori</strong> e <strong>operatori dello sviluppo immobiliare, fondi immobiliari</strong>, clienti con consistenti patrimoni immobiliari (holding dedicate) per gestire deal rilevanti, trophy asset in gestione e partnership con operatori specializzati.`,
        },
      ],

      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: 1.2,
        breakpoints: {
          480: { slidesPerView: 1.4 },
          640: { slidesPerView: 2.2 },
          1024: { slidesPerView: 3 },
        },
      },

      cards: [
        {
          name: 'Vuoi vendere?',
          title: 'Diamo valore alla tua casa',
          imgSrc: 'ucrs-tip-vuoi-vendere.png',
          imgAlt: 'UniCredit RE Services, Valore Casa per chi vende casa',
          link: {
            href: '/vendo',
            text: 'Compila il form o chiamaci',
          },
        },
        {
          name: 'Valuta casa online: facile, veloce, affidabile',
          title: 'Gratis per te il nuovo tool di valutazione',
          imgSrc: 'ucrs-tip-valuta-casa.png',
          imgAlt: 'UniCredit RE Services, Report valore Casa',
          link: {
            href: '/valuta-casa',
            text: 'Scopri di più',
          },
        },
        {
          name: 'Tutte le Novità dal mondo Casa',
          title: 'Una guida chiara e completa',
          imgSrc: 'ucrs-tip-magazine.png',
          imgAlt: 'UniCredit RE Services, magazine',
          link: {
            href: '/news',
            text: 'Leggi il magazine',
          },
        },
      ],
    }
  },
}
</script>
